var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"ma-0",attrs:{"fluid":""}},[_c('div',{staticClass:"container-title"},[_c('v-breadcrumbs',{staticClass:"page-title",attrs:{"items":_vm.items}})],1),_c('v-row',[_c('v-col',{staticClass:"pa-0",attrs:{"cols":"12"}},[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[_vm._t("default")],2)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }